module.exports = __webpack_public_path__ + "img/panelView_strong_Bg_3_3.8730b64e.png";